import { AxiosPromise } from 'axios';

import { api } from 'api';

import { CreateOrderRequest, CreateOrderResponse } from 'features/finance/ts/CreateOrder';
import { TopUpBalanceByCreditCardSummaryOutput } from 'features/finance/ts/TopUpBalanceByCreditCardSummaryOutput';

export const topUpBalanceByCreditCard = (orderData: CreateOrderRequest): AxiosPromise<CreateOrderResponse> =>
  api.post(`/partners/top-up-balance-by-credit-card/`, orderData);

export const getTopUpBalanceByCreditCardSummary = (
  amount: number,
  currency: string
): AxiosPromise<TopUpBalanceByCreditCardSummaryOutput> =>
  api.get('/partners/top-up-balance-by-credit-card/summary/', {
    params: {
      amount,
      currency,
    },
  });

